import { IntlProvider } from "react-intl";
import { useMemo } from "react";

import messages from "@/messages/fr.json";
import { defaultLocale } from "@/i18n/config";

function flattenMessages(
  nested: Record<string, unknown>,
  prefix = "",
): Record<string, string> {
  return Object.entries(nested).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      const path = prefix ? `${prefix}.${key}` : key;
      if (value && typeof value === "object" && !Array.isArray(value)) {
        Object.assign(
          acc,
          flattenMessages(value as Record<string, unknown>, path),
        );
      } else if (typeof value === "string") {
        acc[path] = value;
      }
      return acc;
    },
    {},
  );
}

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const flatMessages = useMemo(() => flattenMessages(messages), []);

  return (
    <IntlProvider locale={defaultLocale} messages={flatMessages}>
      {children}
    </IntlProvider>
  );
}
